/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum BasicPriority {
    None = 0,
    Trivial = 1,
    VeryLow = 2,
    Low = 3,
    Medium = 4,
    High = 5,
    Critical = 6,
}
